module.exports = __webpack_public_path__ + "static/img/page_TITLE.acc743f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series5/course2/page_TITLE.png
// module id = t21j
// module chunks = 0